import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAuth0 } from '@auth0/auth0-react';
import { addAccessTokenInterceptor } from '../../services/rest';
import LoadingPage from '@/pages/LoadingPage/LoadingPage';
import { Button } from '@monavate/ui-core';
import { clientViewService } from '@/helpers/clientViewService';
import { registerAuth0Handlers } from '@/services/auth/tokenService';

const Wrapper = styled.div`
    box-sizing: border-box;
    padding: 40px 40px 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: 100vh;
`;

const ErrorTitle = styled.div`
    font-family: 'Poppins';
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    color: #0f1742 /* TODO: need to change color. There is no such color in themes.ts */;
    margin-top: 40px;
`;

const ErrorText = styled.div`
    font-family: 'Nunito';
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #0f1742 /* TODO: need to change color. There is no such color in themes.ts */;
    margin-top: 15px;
    margin-bottom: 30px;
`;

const ButtonContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

export const Auth0StatusWrapper = ({ children }: { children: any }) => {
    const [initialised, setInitialised] = useState<boolean>(false);
    const { isLoading, error, isAuthenticated, loginWithRedirect, getAccessTokenSilently, logout } =
        useAuth0();

    useEffect(() => {
        if (!isAuthenticated && !isLoading && !error) {
            // loginWithRedirect();
        }

        if (!isLoading) {
            setInitialised(true);
        }
    }, [isLoading, isAuthenticated]);

    // The token service lives outside React but needs the Auth0 methods to renew a token
    // and to sign the user out when renewal is impossible, so they are handed over here
    // and refreshed whenever the Auth0 client rebuilds them.
    useEffect(() => {
        registerAuth0Handlers({ getAccessTokenSilently, loginWithRedirect, logout });
    }, [getAccessTokenSilently, loginWithRedirect, logout]);

    // Attaches the Authorization header to every REST call, once the user is authenticated
    // so public routes are not blocked waiting for a token. The interceptor reads the token
    // through the service, so it is registered only once and survives re-renders.
    useEffect(() => {
        if (!isAuthenticated) return;
        addAccessTokenInterceptor();
    }, [isAuthenticated]);

    if (error) {
        return (
            <Wrapper>
                <ErrorTitle>Failed to login</ErrorTitle>
                <ErrorText>{error.message}</ErrorText>

                {/*@ts-ignore*/}
                {error?.error === 'access_denied' && (
                    <>
                        <div>Or</div> <br />
                        <Button
                            handleClick={() => {
                                clientViewService.clearClientViewData();
                                logout({ logoutParams: { returnTo: window.location.origin } });
                            }}
                        >
                            <ButtonContent>
                                <span className="material-symbols-sharp">logout</span> Sign out
                            </ButtonContent>
                        </Button>
                    </>
                )}
            </Wrapper>
        );
    }

    if (isLoading || !initialised) {
        return <LoadingPage />;
    }

    return initialised ? <>{children}</> : null;
};
